import { Box, Typography, Container, useMediaQuery, useTheme, Grid, Link } from '@mui/material';

function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        backgroundColor: 'black',
        color: 'white',
        py: isMobile ? 4 : 5,
        textAlign: 'left',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        mt: 'auto',
        position: 'relative',
        zIndex: 5
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="body2"
            sx={{
              opacity: 0.7,
              letterSpacing: '0.05em',
              fontSize: '0.9rem',
              mb: 2
            }}
          >
            Need to contact us? Email us at <Link href="mailto:info@screamify.com" sx={{ color: '#fff', '&:hover': { color: '#ff0000' } }}>info@screamify.com</Link>
          </Typography>
        </Box>
        
        <Grid container spacing={2} sx={{ mb: 4 }}>
          {/* On mobile: stack in single column, on desktop: use 3 columns */}
          <Grid item xs={12} sm={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2.5, sm: 2 } }}>
              <Link 
                href="/terms" 
                underline="always" 
                sx={{ 
                  color: '#fff', 
                  opacity: 0.7, 
                  '&:hover': { opacity: 1, color: '#ff0000' },
                  textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                  fontSize: '0.9rem',
                  position: 'relative',
                  zIndex: 10,
                  display: 'inline-block',
                  cursor: 'pointer'
                }}
              >
                Terms of Service
              </Link>
              
              {isMobile ? null : (
                <>
                  <Link 
                    href="/faq" 
                    underline="always" 
                    sx={{ 
                      color: '#fff', 
                      opacity: 0.7, 
                      '&:hover': { opacity: 1, color: '#ff0000' },
                      textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                      fontSize: '0.9rem',
                      position: 'relative',
                      zIndex: 10,
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    FAQ
                  </Link>
                  
                  <Link 
                    href="/shop" 
                    underline="always" 
                    sx={{ 
                      color: '#fff', 
                      opacity: 0.7, 
                      '&:hover': { opacity: 1, color: '#ff0000' },
                      textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                      fontSize: '0.9rem',
                      position: 'relative',
                      zIndex: 10,
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    Store
                  </Link>
                </>
              )}
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2.5, sm: 2 } }}>
              <Link 
                href="/privacy" 
                underline="always" 
                sx={{ 
                  color: '#fff', 
                  opacity: 0.7, 
                  '&:hover': { opacity: 1, color: '#ff0000' },
                  textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                  fontSize: '0.9rem',
                  position: 'relative',
                  zIndex: 10,
                  display: 'inline-block',
                  cursor: 'pointer'
                }}
              >
                Privacy Policy
              </Link>
              
              {isMobile ? (
                <Link 
                  href="/faq" 
                  underline="always" 
                  sx={{ 
                    color: '#fff', 
                    opacity: 0.7, 
                    '&:hover': { opacity: 1, color: '#ff0000' },
                    textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                    fontSize: '0.9rem',
                    position: 'relative',
                    zIndex: 10,
                    display: 'inline-block',
                    cursor: 'pointer'
                  }}
                >
                  FAQ
                </Link>
              ) : (
                <>
                  <Link 
                    href="/blog" 
                    underline="always" 
                    sx={{ 
                      color: '#fff', 
                      opacity: 0.7, 
                      '&:hover': { opacity: 1, color: '#ff0000' },
                      textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                      fontSize: '0.9rem',
                      position: 'relative',
                      zIndex: 10,
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    Blog
                  </Link>
                  
                  <Link 
                    href="/subscribe" 
                    underline="always" 
                    sx={{ 
                      color: '#fff', 
                      opacity: 0.7, 
                      '&:hover': { opacity: 1, color: '#ff0000' },
                      textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                      fontSize: '0.9rem',
                      position: 'relative',
                      zIndex: 10,
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    Subscribe
                  </Link>
                </>
              )}
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2.5, sm: 2 } }}>
              <Link 
                href="/about" 
                underline="always" 
                sx={{ 
                  color: '#fff', 
                  opacity: 0.7, 
                  '&:hover': { opacity: 1, color: '#ff0000' },
                  textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                  fontSize: '0.9rem',
                  position: 'relative',
                  zIndex: 10,
                  display: 'inline-block',
                  cursor: 'pointer'
                }}
              >
                About
              </Link>
              
              {isMobile && (
                <>
                  <Link 
                    href="/shop" 
                    underline="always" 
                    sx={{ 
                      color: '#fff', 
                      opacity: 0.7, 
                      '&:hover': { opacity: 1, color: '#ff0000' },
                      textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                      fontSize: '0.9rem',
                      position: 'relative',
                      zIndex: 10,
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    Store
                  </Link>
                  
                  <Link 
                    href="/blog" 
                    underline="always" 
                    sx={{ 
                      color: '#fff', 
                      opacity: 0.7, 
                      '&:hover': { opacity: 1, color: '#ff0000' },
                      textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                      fontSize: '0.9rem',
                      position: 'relative',
                      zIndex: 10,
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    Blog
                  </Link>
                  
                  <Link 
                    href="/subscribe" 
                    underline="always" 
                    sx={{ 
                      color: '#fff', 
                      opacity: 0.7, 
                      '&:hover': { opacity: 1, color: '#ff0000' },
                      textDecorationColor: 'rgba(255, 255, 255, 0.3)',
                      fontSize: '0.9rem',
                      position: 'relative',
                      zIndex: 10,
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    Subscribe
                  </Link>
                </>
              )}
            </Box>
          </Grid>
        </Grid>

        {/* Language selector similar to Netflix */}
        <Box sx={{ 
          mb: 4, 
          display: 'flex', 
          justifyContent: 'center'
        }}>
          <Box sx={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            border: '1px solid rgba(255, 255, 255, 0.3)', 
            borderRadius: '4px',
            padding: '8px 12px'
          }}>
            <Typography component="span" sx={{ opacity: 0.7, mr: 1, fontSize: '0.9rem' }}>
              🌐 English
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body2"
          sx={{
            opacity: 0.7,
            letterSpacing: '0.1em',
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            textAlign: 'center',
            mx: 'auto'
          }}
        >
          SO GOOD ENTERTAINMENT LLC © {new Date().getFullYear()}
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer; 